







































































































































































import { Account } from '@/@types/Account';
import { ProjectMemberResponse } from '@/@types/ProjectMember';
import { Component, Prop, Vue } from 'vue-property-decorator';

@Component({
  components: {
  },
})
export default class ProfileTab extends Vue {
  @Prop({ required: true })
  private selectedAccount!: Account | null;

  @Prop({ required: true })
  private selectedProjectMember!: ProjectMemberResponse;
}
